import {
  Button,
  DrawerOverlay,
  HexIcon,
  Placeholder as StatusMessage,
  Stack,
} from '@cast/design-system';

type Props = {
  onCancel: () => void;
  onDelete: () => void;
};

export const DeleteOverlay = ({ onCancel, onDelete }: Props) => {
  return (
    <DrawerOverlay>
      <StatusMessage
        icon={<HexIcon variant="error" />}
        title="Are you sure you want to delete alert?"
        body={<>This action cannot be undone.</>}
        actions={
          <Stack direction="row" gap="16px">
            <Button
              variant="secondary"
              size="md"
              onClick={(e) => {
                e.stopPropagation();
                onCancel();
              }}
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              size="md"
              onClick={(e) => {
                e.stopPropagation();
                onDelete();
              }}
              testId="delete-alert-button"
            >
              Delete
            </Button>
          </Stack>
        }
      />
    </DrawerOverlay>
  );
};
